import {PatchReplacePassword} from '../backend/requests/patch-replace-password';
import {PostRecoverPassword} from '../backend/requests/post-recover-password';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class AuthenticationRepository {
  // Singleton Instance
  private static _instance: AuthenticationRepository;

  // Private
  private logger: Logger;

  static get instance(): AuthenticationRepository {
    if (!this._instance) {
      this._instance = new AuthenticationRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('AuthenticationRepository');
  }

  // Ask for a recover password request
  public async recover(body: PostRecoverPassword): Promise<void> {
    // Request password recovery
    await BackendApiManager.instance.post<any>('/authentication/password/recover', body);
  }

  // Replace the password by another
  public async replace(body: PatchReplacePassword): Promise<void> {
    // Replace password
    await BackendApiManager.instance.patch<any>('/authentication/password/replace', body);
  }
}
